import { useEffect, useState } from "react";
import styles from "../../../homepage/pages/Calculators.module.css";
import { analytics, logEvent } from "../../../../firebase.js";

import { BlockMath } from "react-katex";
import "katex/dist/katex.min.css";

import Select from "../components/Select.js";
import InputNumber from "../components/InputNumber.js";
import Output from "../components/Output.js";
import CrossBar from "../components/CrossBar.js";

import { concreteTorsion } from "../../utils/services/calculators.js";
import { Text, useToast } from "@chakra-ui/react";

function ConcreteTorsion({}) {
  const toast = useToast();
  // TORSION
  const [torsionInputs, setTorsionInputs] = useState({
    fck: 20,
    fyk: 500,
    b: "",
    h: "",
    c1: "",
    tsd: "",
    model: "I",
    teta: 45,
  });
  const [torsionOutputs, setTorsionOutputs] = useState({
    trd2: "",
    a90: "",
    a90_min: "",
    asl: "",
    asl_min: "",
    memorial: {},
  });

  function updateTorsionInputs(name, value) {
    if (name === "model") {
      setTorsionInputs((prevInputs) => ({
        ...prevInputs,
        [name]: value,
      }));
      if (name === "model" && value === "I") {
        setTorsionInputs((prevInputs) => ({
          ...prevInputs,
          teta: 45,
        }));
      }
      if (name === "model" && value === "II") {
        setTorsionInputs((prevInputs) => ({
          ...prevInputs,
          teta: "",
        }));
      }
    } else if (value === "") {
      setTorsionInputs((prevInputs) => ({
        ...prevInputs,
        [name]: value,
      }));
    } else {
      setTorsionInputs((prevInputs) => ({
        ...prevInputs,
        [name]: parseFloat(value),
      }));
    }
    setTorsionOutputs({
      trd2: "",
      a90: "",
      a90_min: "",
      asl: "",
      asl_min: "",
      memorial: {},
    });
  }

  function onTorsionCalculate() {
    if (
      torsionInputs["b"] === "" ||
      torsionInputs["h"] === "" ||
      torsionInputs["c1"] === "" ||
      torsionInputs["tsd"] === "" ||
      torsionInputs["teta"] === ""
    ) {
      toast({
        title: "Preencha todos os campos",
        status: "warning",
        isClosable: true,
      });
    } else if (
      torsionInputs["b"] === 0 ||
      torsionInputs["h"] === 0 ||
      torsionInputs["c1"] === 0 ||
      torsionInputs["tsd"] === 0 ||
      torsionInputs["teta"] === 0
    ) {
      toast({
        title: "Os valores devem ser diferentes de 0",
        status: "warning",
        isClosable: true,
      });
    } else if (
      torsionInputs["model"] === "II" &&
      (torsionInputs["teta"] < 30 || torsionInputs["teta"] > 45)
    ) {
      toast({
        title: "O ângulo teta deve possui um valor entre 30º e 45º",
        status: "warning",
        isClosable: true,
      });
    } else {
      concreteTorsion(torsionInputs).then((response) => {
        setTorsionOutputs(response["data"]);
        logEvent(analytics, "button_click", {
          button_name: "concrete-torsion-calculator-button",
        });
      });
    }
  }

  useEffect(() => {
    logEvent(analytics, "page_view", { page: "concrete-torsion-calculator" });
  }, []);

  return (
    <div className={styles.section} key={"header"}>
      <h1 className={styles.calculatorName}>Torção:</h1>
      <div className={styles.calculator}>
        <div className={styles.inputs}>
          <div className={styles.inputRow}>
            <h3 className={styles.rowTitle}>Dados de entrada:</h3>
          </div>
          <div className={styles.inputRow}>
            <Select
              text="Seção"
              elements={["Retangular"]}
              unit=""
              // onChange={(e) => updateBendingInputs("fck", e.target.value)}
            />
          </div>
          <div className={styles.inputRow}>
            <Select
              text="fck"
              elements={[
                20, 25, 30, 35, 40, 45, 50, 55, 60, 65, 70, 75, 80, 85, 90,
              ]}
              unit="MPa"
              onChange={(e) => updateTorsionInputs("fck", e.target.value)}
            />
            <Select
              text="fyk"
              elements={[500, 600]}
              unit="MPa"
              onChange={(e) => updateTorsionInputs("fyk", e.target.value)}
            />
          </div>
          <div className={styles.inputRow}>
            <InputNumber
              text="b"
              unit="cm"
              onChange={(e) => updateTorsionInputs("b", e.target.value)}
            />
            <InputNumber
              text="h"
              unit="cm"
              onChange={(e) => updateTorsionInputs("h", e.target.value)}
            />
          </div>
          <div className={styles.inputRow}>
            <InputNumber
              text="c1"
              unit="cm"
              onChange={(e) => updateTorsionInputs("c1", e.target.value)}
            />
          </div>
          <div className={styles.inputRow}>
            <InputNumber
              text="Tsd"
              unit="tf.m"
              onChange={(e) => updateTorsionInputs("tsd", e.target.value)}
            />
          </div>
          <div className={styles.inputRow}>
            <Select
              text="Modelo"
              elements={["I", "II"]}
              unit=""
              onChange={(e) => updateTorsionInputs("model", e.target.value)}
            />
            {torsionInputs["model"] === "I" ? (
              <Text>θ=45º</Text>
            ) : (
              <InputNumber
                text="θ"
                unit="º"
                onChange={(e) => updateTorsionInputs("teta", e.target.value)}
              />
            )}
          </div>
        </div>
        <div className={styles.buttons}>
          <button
            className={styles.calculateButton}
            onClick={onTorsionCalculate}
          >
            CALCULAR
          </button>
        </div>
        <div className={styles.outputs}>
          <div className={styles.outputRow}>
            <h3 className={styles.rowTitle}>Resumo de resultados:</h3>
          </div>
          <Output text="Trd2" value={torsionOutputs["trd2"]} unit="kN.cm" />
          <Output text="A90" value={torsionOutputs["a90"]} unit="cm²/m - 1R" />
          <Output
            text="A90,mín"
            value={torsionOutputs["a90_min"]}
            unit="cm²/m - 2R"
          />
          <Output text="Asl" value={torsionOutputs["asl"]} unit="cm²" />
          <Output text="Asl,mín" value={torsionOutputs["asl_min"]} unit="cm²" />
          <CrossBar fyk={torsionInputs["fyk"]} />
        </div>
      </div>
      <div className={styles.memorial} key={"memorial"}>
        <h1>Memorial de Cálculo:</h1>
        {torsionOutputs["memorial"] &&
          Object.entries(torsionOutputs["memorial"]).map(
            ([className, subclasses]) => (
              <>
                <h2>{className}</h2>
                {Object.entries(subclasses).map(([subclassName, steps]) => (
                  <>
                    <h3>{subclassName}</h3>
                    {steps.map((step) => (
                      <>
                        <h4>{step["description"]}</h4>
                        <div className={styles.mathContainer}>
                          <BlockMath
                            math={step["formula"] + step["calculation"]}
                          />
                        </div>
                      </>
                    ))}
                  </>
                ))}
              </>
            )
          )}
      </div>
    </div>
  );
}

export default ConcreteTorsion;
